import React from 'react'
import { Skeleton, Space } from '@mantine/core'
import { useMediumScreen } from '@/hooks'

const AirdropSkeleton = () => {
  const { isMediumScreen } = useMediumScreen()

  return (
    <>
      <Skeleton height={12} width={isMediumScreen ? 320 : 140} />

      <Space h="xs" />

      <Skeleton height={12} width={isMediumScreen ? 320 : 140} />

      <Space h="md" />

      <Skeleton height={isMediumScreen ? 106 : 150} width="100%" mb="sm" />
      <Skeleton height={isMediumScreen ? 106 : 150} width="100%" mb="sm" />
      <Skeleton height={isMediumScreen ? 106 : 150} width="100%" mb="sm" />
      <Skeleton height={isMediumScreen ? 106 : 150} width="100%" mb="sm" />
    </>
  )
}

export { AirdropSkeleton }
